/******/ (() => { // webpackBootstrap
/*!***************************************!*\
  !*** ./src/js/nextpage/next-offer.js ***!
  \***************************************/
  class NextOffer extends HTMLElement {
    constructor() {
        super();
        this.exchange_discount = this.getAttribute('data-exchange-discount') ? parseInt(this.getAttribute('data-exchange-discount')) : 0;
        this.sale_discount = this.getAttribute('data-sale-discount') ? parseInt(this.getAttribute('data-sale-discount')) : 0;
        this.referral_discount = this.getAttribute('data-referral-discount') ? parseInt(this.getAttribute('data-referral-discount')) : 0;
        this.discount_amount = this.getAttribute('data-discount-amount') ? parseInt(this.getAttribute('data-discount-amount')) : 0;
        this.product_price = this.getAttribute('data-product-price') ? parseInt(this.getAttribute('data-product-price')) : 0;
    }
    connectedCallback() {
        this.init(); 
    }
    async init() {
        await getReferralGlobal();
        this.setup()
        this.threeInit()
        this.setupRichText();
    }
    setup() {

        this.querySelector('.next-offer-left-details-explore-btn').addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            document.querySelector('.modal-emi').classList.add('show');
        });

        document.querySelector('.icon-close').addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            document.querySelector('.modal-emi').classList.remove('show');
        });

        document.querySelector('.modal-dialog').addEventListener('click', (e) => {
            if(!document.querySelector('.modal-content').contains(e.target)) {
                document.querySelector('.modal-emi').classList.remove('show');
            }
        })

        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.querySelector('.next-offer-left'),
                start: () => {
                    return `top top+=${getScreenType().isDesktop ? 90 : 70}%`
                }
            }
        });
        const btnColorChanges = this.querySelectorAll('.next-offer-left-fashion-choose-item');
        btnColorChanges.forEach(btn => {
            btn.addEventListener('click', () => {
                let name = btn.getAttribute('data-name');
                btnColorChanges.forEach(btn => {
                    btn.classList.remove('active')
                })
                btn.classList.add('active');
                let colorSide;
                switch (name) {
                    case 'Black & White':
                        colorSide = new THREE.Color(0xFFFFFF);
                        gsap.to(this.panels.material.color, { r: colorSide.r, g: colorSide.g, b: colorSide.b, duration: .2, ease: 'power1.inOut', overwrite: true });
                        gsap.to(this.panels.material, { roughness: .9, duration: .2, ease: 'power1.inOut', overwrite: true });
                        break;
                    case 'Black & Grey':
                        colorSide = new THREE.Color(0x848587);
                        gsap.to(this.panels.material.color, { r: colorSide.r, g: colorSide.g, b: colorSide.b, duration: .2, ease: 'power1.inOut', overwrite: true });
                        gsap.to(this.panels.material, { roughness: .7, duration: .2, ease: 'power1.inOut', overwrite: true });
                        break;
                    default:
                        break;
                }
            })
        });

        this.tl.from(this.querySelector('.next-offer-right-nav'), {
            gap: '0',
            opacity: 0,
            ease: 'power3.out',
            duration: 1.2
        });

        // new MasterTimeline({
        //     triggerInit: this.querySelector('.next-offer-left'), timeline: this.tl, tweenArr: [
        //         getScreenType().isMobile && new FadeSplitText({ el: this.querySelector('.next-offer-left-fashion-top .txt') }),
        //         ...(getScreenType().isMobile ? Array.from(this.querySelectorAll('.next-offer-left-fashion-choose')).flatMap((item, idx) => {
        //             return [
        //                 new FadeIn({ el: item, from: { y: parseRem(24) }, delay: idx / 10 }),
        //             ]
        //         }) : []),
        //         new FadeSplitText({ el: this.querySelector('.next-offer-left-label .txt') }),
        //         new FadeSplitText({ el: this.querySelector('.next-offer-left-oldprice .txt') }),
        //         new FadeSplitText({ el: this.querySelector('.next-offer-left-newprice-label .txt') }),
        //         new FadeSplitText({ el: this.querySelector('.next-offer-left-newprice-save .txt') }),
        //         new ScaleLine({ el: this.querySelector('.next-offer-left-details .div-line') }),
        //         new FadeSplitText({ el: this.querySelector('.next-offer-left-details-label .txt') }),
        //         new FadeSplitText({ el: this.querySelector('.next-offer-left-details-explore-label .txt') }),
        //         new FadeSplitText({ el: this.querySelector('.next-offer-left-details-explore-btn .txt') }),
        //         ...Array.from(this.querySelectorAll('.next-offer-left-details-list-item')).flatMap((item) => {
        //             return [
        //                 new ScaleLine({ el: item.querySelector('.div-line') }),
        //                 new FadeIn({
        //                     el: item.querySelector('.next-offer-left-details-list-item-label'),
        //                     from: { y: parseRem(20) }
        //                 }),
        //                 new FadeIn({ el: item.querySelector('.next-offer-left-details-list-item-sub'), from: { y: parseRem(20) } }),
        //             ]
        //         }),
        //         new FadeIn({ el: this.querySelector('.next-offer-left-details-btn') }),
        //         new FadeSplitText({ el: this.querySelector('.next-offer-left-details-note .txt'), delay: '<=0.2' }),
        //         new ScaleLine({ el: this.querySelector('.next-offer-left-fashion .div-line') }),
        //         !getScreenType().isMobile && new FadeSplitText({ el: this.querySelector('.next-offer-left-fashion-content .txt') }),
        //         ...(!getScreenType().isMobile ? Array.from(this.querySelectorAll('.next-offer-left-fashion-choose')).flatMap((item, idx) => {
        //             return [
        //                 new FadeIn({ el: item, from: { y: parseRem(24) }, delay: idx / 10 }),
        //             ]
        //         }) : []),
        //         new FadeIn({ el: this.querySelector('.next-offer-left-fashion-refund-icon'), from: { y: parseRem(24) } }),
        //         new FadeSplitText({ el: this.querySelector('.next-offer-left-fashion-refund-content-label .txt') }),
        //         new FadeSplitText({ el: this.querySelector('.next-offer-left-fashion-refund-content-sub .txt') }),
        //     ],
        //     stagger: 0.075
        // });
        // new MasterTimeline({
        //     triggerInit: this,
        //     scrollTrigger: { trigger: this.querySelector('.next-offer-right') },
        //     tweenArr: [ new FadeIn({ el: this.querySelector('.next-offer-right-product-canvas') }) ]
        // })
    }
    threeInit() {
        const scene = new THREE.Scene();
        const el = this.querySelector('.next-offer-right-product .next-offer-right-product-canvas');

        const yPositionMap = {
            mb: -0.8,
            tb: -0.6,
            dsk: -0.2
        }[getScreenType().type];

        el.addEventListener('mousedown', () => {
            if (this.autoTurn) {
                this.autoTurn = false;
            }
            el.style.cursor = 'grabbing'
        });
        el.addEventListener('mouseup', () => {
            if (this.autoTurn == false) {
                this.autoTurn = true;
            }
            el.style.cursor = 'grab'
        });

        const camera = new THREE.PerspectiveCamera(30, el.clientWidth / el.clientHeight, 0.1, 1000);
        const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(el.clientWidth, el.clientHeight);
        renderer.domElement.style.position = 'absolute';
        renderer.domElement.style.top = '0';
        renderer.encoding = THREE.sRGBEncoding;
        renderer.physicallyCorrectLights = true;
        el.appendChild(renderer.domElement);

        this.autoTurn = true;
        const controls = new OrbitControls(camera, renderer.domElement);
        controls.enablePan = false;
        controls.enableZoom = false;
        controls.minPolarAngle = Math.PI / 2;
        controls.maxPolarAngle = Math.PI / 2;
        controls.enableDamping = true;

        const loader = new GLTFLoader();
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        loader.setDRACOLoader(dracoLoader);

        let obj;
        const path = this.getAttribute('data-glb');
        loader.load(path, (gltf) => {
            gltf.scene.traverse((child) => {
                obj = gltf.scene;
                let toRemove = [];
                obj.children[0].children.map((child) => {
                    if (child.name.includes('roti')) {
                        toRemove.push(child)
                    }
                })
                toRemove.map((child) => {
                    obj.children[0].remove(child);
                    child.geometry.dispose();
                    scene.remove(child)
                    child.remove();
                })
                if (child instanceof THREE.Mesh) {
                    child.castShadow = true;
                    switch (child.name) {
                        case 'screen_remove':
                            this.screen = child;
                            this.screen.material.map = null
                            this.screen.material.color = new THREE.Color(0x0C0C0C);
                            this.screen.material.emissiveMap = null
                            this.screen.material.emissive = null
                            break;
                        case 'Boss-Extrude51':
                            this.door = child;
                            this.door.material.color = new THREE.Color(0x1F1F1F);
                            break;
                        case 'DeleteFace3':
                            this.panels = child;
                            let name = this.querySelector('.next-offer-left-fashion-choose-item.active').getAttribute('data-name')

                            let colorSide;
                            switch (name) {
                                case 'Black & White':
                                    colorSide = new THREE.Color(0xFFFFFF);
                                    gsap.to(this.panels.material.color, { r: colorSide.r, g: colorSide.g, b: colorSide.b, duration: .2, ease: 'power1.inOut', overwrite: true });
                                    gsap.to(this.panels.material, { roughness: .9, duration: .2, ease: 'power1.inOut', overwrite: true });
                                    break;
                                case 'Black & Grey':
                                    colorSide = new THREE.Color(0x848587);
                                    gsap.to(this.panels.material.color, { r: colorSide.r, g: colorSide.g, b: colorSide.b, duration: .2, ease: 'power1.inOut', overwrite: true });
                                    gsap.to(this.panels.material, { roughness: .7, duration: .2, ease: 'power1.inOut', overwrite: true });
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 'Move_Face13_649':
                            child.material.metalness = 1;
                            child.material.roughness = 0.2;
                            break;
                        case 'Move_Face13_658_2':
                            child.material.metalness = .6;
                            child.material.opacity = .95;
                            break;
                        case 'Fillet4':
                            child.material.specularIntensity = 0.9;
                            child.material.roughness = 0.2;
                            break;
                        case 'Fillet8_412':
                            child.material.roughness = 0;
                            break;
                    }
                }
            });

            obj.scale.set(10, 10, 10);
            obj.position.set(0, yPositionMap, 0);
            scene.add(obj);

            new FadeIn({ el: this.querySelector('.next-offer-right-product-canvas') })
        }, undefined, (error) => console.error(error));

        camera.position.set(0, 2, 11);
        camera.lookAt(0, 0, 0);

        const hdrLoader = new RGBELoader();
        const hdrPath = this.getAttribute('data-hdr');
        hdrLoader.load(hdrPath, (texture) => {
            texture.mapping = THREE.EquirectangularReflectionMapping;
            texture.encoding = THREE.sRGBEncoding;
            scene.environment = texture;
            scene.environmentIntensity = 1.05;
        });
        const animate = () => {
            requestAnimationFrame(animate);
            if (isInViewport(el)) {
                if (obj && this.autoTurn) {
                    obj.rotation.y += .004
                }
                controls.update();
                renderer.render(scene, camera);
            }
        };

        animate();
        function onWindowResize() {
            camera.aspect = el.clientWidth / el.clientHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(el.clientWidth, el.clientHeight);
        }
        window.addEventListener('resize', onWindowResize);
    }
    setupRichText() {
        const listContents = this.querySelectorAll('.next-offer-left-details-list-item');
        listContents.forEach(content => {
            const links = content.querySelectorAll('a');
            if (links.length) {
                links.forEach(link => {
                    const line = document.createElement('div');
                    line.classList.add('not-anim');
                    line.classList.add('div-line');
                    link.classList.add('txt-link', 'hover-un');
                    link.appendChild(line);
                })
            }
        })

        // Exchange Credit Logic 

        const toggleSwitchNext = document.getElementById('toggleSwitchNext');
        const nextPriceText = document.querySelectorAll('.next-offer-left-newprice-label');
        const nextSaveText = document.querySelectorAll('.next-offer-left-newprice-save');
        const sliderNext = document.querySelector('.sliderNext');  // Assuming this is the slider element

        // Check initial state on page load (if toggle is already checked, apply necessary styles)
        if (toggleSwitchNext.checked) {
            toggleSwitchNext.setAttribute('checked', 'true'); // Correctly set the 'checked' attribute

            nextPriceText.forEach((element) => {
                const lineElement = element.querySelector('.line'); // Use querySelector instead of find
                if (lineElement) {
                    const discountPrice = formatMoney(((this.product_price - this.discount_amount - this.exchange_discount - this.referral_discoun - this.sale_discount)));
                    lineElement.textContent = discountPrice;
                }
            });

            nextSaveText.forEach((element) => {
                const lineElement = element.querySelector('.line'); // Use querySelector instead of find
                if (lineElement) {
                    lineElement.textContent = `(You saved ${formatMoney(this.discount_amount + this.referral_discount + this.sale_discount)} + Exchange ${formatMoney(this.exchange_discount)})`;
                }
            });

            localStorage.setItem('ExchangeSelected', 'true');
        }

        toggleSwitchNext.addEventListener('change',() => {
            if (toggleSwitchNext.checked) {
                // Correctly add the 'checked' attribute
                toggleSwitchNext.setAttribute('checked', 'true');

                // Change text content
                nextPriceText.forEach((element) => {
                    const lineElement = element.querySelector('.txt'); // Use querySelector instead of find
                    if (lineElement) {
                        const discountPrice = formatMoney(((this.product_price - this.discount_amount - this.exchange_discount - this.referral_discount - this.sale_discount)));
                        lineElement.textContent = `${discountPrice}`;
                    }
                });

                nextSaveText.forEach((element) =>{
                    const lineElement = element.querySelector('.txt'); // Use querySelector instead of find
                    if (lineElement) {
                        lineElement.textContent = `(You saved ${formatMoney(this.discount_amount + this.referral_discount + this.sale_discount)} + Exchange ${formatMoney(this.exchange_discount)})`;
                    }
                });

                // Set localStorage variable
                localStorage.setItem('ExchangeSelected', 'true');
            } else {
                // Remove the 'checked' attribute
                toggleSwitchNext.removeAttribute('checked');

                // Reset text content or change it back to the default
                nextPriceText.forEach((element) =>{
                    const lineElement = element.querySelector('.txt'); // Use querySelector instead of find
                    if (lineElement) {
                        const discountPrice = formatMoney(((this.product_price - this.discount_amount - this.referral_discount - this.sale_discount)));

                        lineElement.textContent = `${discountPrice}`; // Or set it to something else if needed
                    }
                });

                nextSaveText.forEach((element) => {
                    const lineElement = element.querySelector('.txt'); // Use querySelector instead of find
                    if (lineElement) {
                        lineElement.textContent = `(You saved ${formatMoney(this.discount_amount + this.referral_discount + this.sale_discount)})`; // Or set it to something else if needed
                    }
                });

                // Remove localStorage variable
                localStorage.setItem('ExchangeSelected', 'false');
            }
        });

        // Exchange Credit Logic Ends

    
        document.addEventListener('DOMContentLoaded', function () {
            const activeCurrency = Shopify.currency.active;
            const blockItems = document.querySelectorAll('.next-offer-left-details-list-item');
            
            blockItems.forEach(blockItem => {
            const textElement = blockItem.querySelector('.next-offer-left-details-list-item-label-text span');
            if (textElement && textElement.textContent.includes('Shipping')) {
                if (activeCurrency !== 'USD' && activeCurrency !== 'CAD') {
                textElement.textContent = 'Free Shipping Available (12-16 Weeks)';
                }
            }
            });
        });
          
    }
}

customElements.define('next-offer', NextOffer);
/******/ })()
;
//# sourceMappingURL=next-offer.js.map